// extracted by mini-css-extract-plugin
export var container = "_g0-1";
export var editor = "_g0-2";
export var resizable = "_g0-3";
export var wrapper = "_g0-0";